import breakpoints from 'scss-settings/_settings.grid.scss';
import DetectBreakpoints from '~utilities/detect-breakpoints';

const JS_STICKY_BREAKPOINT = 'js-sticky-breakpoint';
const JS_STICKY = 'js-sticky';
const STICKY_CLASS = 'is--sticky';
const UNSTICKY_CLASS = 'is--unsticky';

class Sticky {
    constructor(element) {
	    this.element = element;
	    this.offset = this.element.getAttribute(JS_STICKY)
	    this.top = this.getTop(this.element);
	    
	    this.bottom = this.element.offsetHeight;
	    const width = this.element.offsetWidth;
	    
	    this.element.style.width = `${width}px`;
	    
	    this.checkBreakpoint();
    }

    getTop(element) {
        return element.getBoundingClientRect().top - document.body.getBoundingClientRect().top - this.offset;
    }
    
    checkBreakpoint() {
	    const envs = Object.keys(breakpoints);
        const minBreakpoint = envs.indexOf(this.element.getAttribute(JS_STICKY_BREAKPOINT));
	    const breakpoint = envs.indexOf(DetectBreakpoints.breakpoint);
	    
	    if(minBreakpoint <= breakpoint) {
			this.toggleSticky();
	        this.bindEvents();
	    }
    }

    bindEvents() {	
		window.addEventListener('scroll', () => this.throttle());
    }
    
    throttle() {
	    if(this.scrollInterval){
		    window.clearTimeout(this.scrollInterval);
		};
	    this.scrollInterval = setTimeout(() => {
		    this.toggleSticky();
	    },10);
    }
    
    toggleSticky() {
	    const bodyY = document.documentElement && document.documentElement.scrollTop;	    
	    const bottom = this.bottom + bodyY;
	    
	    const toggleTop = bodyY >= this.top ? 'add' : 'remove';
	    this.element.classList[toggleTop](STICKY_CLASS);
	    
	    const parent = this.element.parentElement;
	    const parentBottom = parent.offsetHeight;
	    const parentTop = this.getTop(parent);

	    const toggleBottom = parentBottom + parentTop <= bottom ? 'add' : 'remove';
	    this.element.classList[toggleBottom](UNSTICKY_CLASS);
    }
}

export default Sticky;